import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SessionStorage } from 'ngx-webstorage';

import { SchoolInfo } from '../application/application.service';
import { AwardProgramInfo, AwardsService } from '../awards/awards.service';
import { takeUntil } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class SettingsService implements OnDestroy {
	@SessionStorage() _CurrentSchool: SchoolInfo;
	@SessionStorage() _CurrentSchoolYear: string;
	private _subrelease: Subject<void> = new Subject<void>();
	public DevSiteSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public CurrentSchoolSubject: BehaviorSubject<SchoolInfo> = new BehaviorSubject<SchoolInfo>(null);
	public CurrentSchoolYearSubject: BehaviorSubject<string>;
	public SchoolYearByDate: string;
	awardInfo: AwardProgramInfo;

	constructor(private awardSvc: AwardsService) {
		let devSite = window.location.hostname.indexOf('localhost') >= 0 || window.location.hostname.indexOf('polkawardsdev') >= 0;
		this.DevSiteSubject.next(devSite);

		this.awardSvc.CurrentAwardsSub.pipe(takeUntil(this._subrelease)).subscribe(res => {
			if (res == null) return;
			this.awardInfo = res;

			let today = new Date();

			if (res.ShortName !== 'TOY') {	//TOY nominations start in April/May, before the school year starts
				today.setMonth(today.getMonth() - 6);	//subtract 6 months so get previous year as first year unless it is currently past June
			}

			let year = today.getFullYear();
			let firstYear = year.toString().substring(2);
			let secondYear = (year + 1).toString().substring(2);
			this.SchoolYearByDate = firstYear + secondYear;

			this.CurrentSchoolYearSubject = new BehaviorSubject<string>(this.SchoolYearByDate);

			//if session storage has value, use that
			if (this._CurrentSchoolYear) {
				this.CurrentSchoolYearSubject.next(this._CurrentSchoolYear);
			}
			//if session storage has value, use that
			if (this._CurrentSchool) {
				this.CurrentSchoolSubject.next(this._CurrentSchool);
			}
		});
	}

	SetSchoolYear(year: string) {
		//set behavior subject
		this.CurrentSchoolYearSubject.next(year);
		//set session storage
		this._CurrentSchoolYear = year;
	}

    SetCurrentSchool(school: SchoolInfo) {
		// Only process if the school has changed
		if (school !== this.CurrentSchoolSubject.getValue()) {
			//set behavior subject
			this.CurrentSchoolSubject.next(school);
			//set session storage
			this._CurrentSchool = school;
        }
	}

	ngOnDestroy() {
		this._subrelease.next();
		this._subrelease.complete();
	}
}

